/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react';
import * as S from './Input.styles';

const Input = (props) => {
  const {label, inputRef, errors} = props;
  return (
    <S.InputContainer>
      <S.Label>{label} </S.Label>
      <S.InputContent ref={inputRef} {...props} />
      {errors && (
        <S.AlignEnd>
          <S.Required>{errors}</S.Required>
        </S.AlignEnd>
      )}
    </S.InputContainer>
  );
};

export default Input;
